<p>events-mld works!</p>
<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Annual Sports Competition 2023
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        Proyash-Chattogram had her annual sports on 20th February 2023. <br />
        Colonel Md Enamul Islam, psc, PhD (Chairman Proyash-Chattogram) graced
        the occasion as the chief guest, Respected Madam as special guest.
        <br />
        Spectators were astounded by the amazing performance of the students.
        <br />
        Under the dynamic leadership of Chairman, teachers and administrative
        staff worked hard to make the event a grand success. <br />
        Thanks to supporting military units & formations, parents, social
        workers, and distinguished guests from different institutions, assisting
        relentlessly towards inclusion. <br />
        Together we are, we can contribute effectively towards inclusion.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
